/*
 * File: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice\src\Content\Car\Car.tsx
 * Project: c:\Users\j.mazat\Desktop\AutobuyBackOffice\AutobuyBackOffice
 * Created Date: Monday June 12th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday, 16th January 2024 10:12:47
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { CarPictureType } from "Type/singleCarDbType";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { useLoaderData } from "react-router-dom";
import translator from "MultiLanguage/TranslationWrapper";
import Styles from "Content/Car/Car.module.css";
import BackArrow from "Content/BackArrow/BackArrow";
import "Content/Car/Car.css";
import DragGalery from "Content/DragGalery/DragGalery";
import CarInfo from "Content/Car/CarData";
import ModalConfirmation from "Content/Modals/ModalConfirmation/ModalConfirmation";
import { UpdateCarInfo, UpdateCarType } from "Type/CarElement.type.hold";
import CarService from "Services/Car/CarService";
import ModalCarPicture from "Content/Modals/ModalCarPicture/ModalCarPicture";
import { Form } from "react-bootstrap";
import ModalSearchUser from "Content/Modals/ModalSearchUser/ModalSearchUser";
import LoadingScreen from "Content/LoadingScreen/LoadingScreen";
import { CarEquipment } from "Content/Equipment/CarEquipment";
import CollapseDiv from "Content/CollapseDiv/CollapseDiv";
import CarSelect from "./CarSelect/CarSelect";
import Config from "Config/Config";
import formatPricing from "Utils/pricing.utils";
import { PriceListRefType, PricingType, PrincingTypeEnum } from "Type/pricing.type";
import Pricing from "Content/Pricing/PricingHolder/pricing";

type CarInputType = string | number | Date | boolean;

type building = {
    [valName: string]: [CarInputType, Function]
};

export default function CarElement() {
    const loadData = useLoaderData() as {editable: boolean, id: string, promises: Promise<any>[]};
    const editable = loadData.editable ?? false;
    const [spinner, setSpinner] = useState(false);
    const [isOkay, setIsOkay] = useState(false);
    const updateData = useRef<UpdateCarType>({update: {}, create: {}, delete: {}});
    const [update, setUpdate] = useState(false);
    const cardTitle = useState("");
    const brand = useState("");
    const model = useState("");
    const version = useState("");
    const energy = useState("");
    const category = useState("");
    const gears = useState("");
    const customText = useState("");
    const subSection = useState("");
    const type = useState("");
    const color = useState("");
    const status = useState("");
    const [commentary, setCommentary] = useState("");
    const [carCustomSubTitle, setCarCustomSubTitle] = useState("");
    const [pictureList, setPictureList] = useState<CarPictureType[]>([]);
    const picturesRef = useRef<CarPictureType[]>([]);
    const [boxes, setBoxes] = useState(pictureList.map((val)=> {return {id: val.id, order: val.Index, Name: val.Pict.Name, Url: val.Pict.URI, toDelete: false }}));
    const dbgears = Config.COMMON.GEARS;

    const [dbEnergy, setDbEnergy] = useState<{id: string, Name: string}[]>([]);
    const [dbCarType, setDbCarType] = useState<{id: string, Name: string}[]>([]);
    const [dbCategories, setDbCategories] = useState<{id: string, Name: string}[]>([]);
    const [dbSubSection, setDbSubSection] = useState({});

    const loaRef = useRef<PriceListRefType>({});
    const lldRef = useRef<PriceListRefType>({});
    const pricingSave = useRef<PricingType[]>([]);

    const dataLeftColumn: building = {"Brand": brand, "Model": model, "Version": version};
    const dataRightColumn = { "Energy": energy, "Type": type, "Color": color};
    const dataPricingLeft = {"CustomText": customText, "Gears": gears, "SubSection": subSection, "Category": category};

    const [openModal, setOpenModal] = useState<boolean>(false);
    const [openPictureModal, setOpenPictureModal] = useState<boolean>(false);
    const [openSendCarModal, setOpenSendCarModal] = useState<boolean>(false);

    useEffect(() => {
        Promise.all(loadData.promises).then(([car, CarPicture, dbData, Pricing]) => {
            const pricing = formatPricing(Pricing.data);
            pricingSave.current = Pricing.data;
            if (pricing.LLD)
                lldRef.current = pricing.LLD;
            if (pricing.LOA)
                loaRef.current = pricing.LOA;

            setPictureList((CarPicture.data as CarPictureType[]).sort((val1, val2) => val1.Index - val2.Index));
            CarPicture.data.forEach((element: CarPictureType) => {
                picturesRef.current.push(
                    {...element}
                );
            });
            brand[1](car.Brand);
            model[1](car.Model);
            version[1](car.Version);
            energy[1](car.Energy.Name);
            gears[1](car.Gears);
            category[1](car.CategoryType.Name);
            customText[1](car.CustomText);
            subSection[1](car.SubSection);
            type[1](car.CarType.Name);
            color[1](car.Color);
            status[1](car.Status);
            setCommentary(car.Comments);
            cardTitle[1](car.Brand + " " + car.Model);
            setCarCustomSubTitle(car.Model + " " + car.Version);
            setDbEnergy(dbData.data[0]);
            setDbCarType(dbData.data[1]);
            setDbCategories(dbData.data[2]);
            setDbSubSection(dbData.data[3]);
        });
    }, []);

    const manageUpdatePricing = (value: number, month: number, mileage: number, type: PrincingTypeEnum) => {
        const isExist = pricingSave.current?.filter(x => x.Type == type && x.Mileage == mileage && x.Month == month);
        if (isExist && isExist.length > 0) {
            if (isExist[0].Amount == value)
                return;
            setUpdate(true);
            if (!updateData.current.update.Pricing)
                updateData.current.update.Pricing = {};
            if (isNaN(value)) {
                delete updateData.current.update.Pricing[isExist[0].id];
                if (!updateData.current.delete.Pricing)
                    updateData.current.delete.Pricing = [];
                updateData.current.delete.Pricing.push(isExist[0].id);
            } else
                updateData.current.update.Pricing[isExist[0].id] = value;
        } else {
            if (!updateData.current.create.Pricing)
                updateData.current.create.Pricing = {};
            if (!updateData.current.create.Pricing[type])
                updateData.current.create.Pricing[type] = {};
            if (!updateData.current.create.Pricing[type][mileage])
                updateData.current.create.Pricing[type][mileage] = {};
            if (isNaN(value))
                delete updateData.current.create.Pricing[type][mileage][month];
            else
                updateData.current.create.Pricing[type][mileage][month] = value;
        }
    };

    const manageDeletePricing = (type: PrincingTypeEnum, month?: number, mileage?: number) => {
        if (month) {
            const isMonth = pricingSave.current?.filter(x => x.Type == type && x.Month == month);
            if (isMonth && isMonth.length > 0) {
                if (!updateData.current.delete.Pricing)
                    updateData.current.delete.Pricing = [];
                // isMonth.forEach(x => updateData.current.delete.Pricing![type]!.push(x.id));
                isMonth.forEach(x => updateData.current.delete.Pricing!.push(x.id));
                if (updateData.current.update.Pricing)
                    isMonth.forEach(x => delete updateData.current.update.Pricing![x.id]);
            }
            if (updateData.current.create.Pricing && updateData.current.create.Pricing[type])
                Object.keys(updateData.current.create.Pricing![type]!).forEach(x => {
                    delete updateData.current.create.Pricing![type]![parseInt(x)][month];
                });
        }
        if (mileage) {
            const isMileage = pricingSave.current?.filter(x => x.Type == type && x.Mileage == mileage);
            if (isMileage && isMileage.length > 0) {
                if (!updateData.current.delete.Pricing)
                    updateData.current.delete.Pricing = [];
                // isMileage.forEach(x => updateData.current.delete.Pricing![type]!.push(x.id));
                isMileage.forEach(x => updateData.current.delete.Pricing!.push(x.id));
                if (updateData.current.update.Pricing)
                    isMileage.forEach(x => delete updateData.current.update.Pricing![x.id]);
            }
            if (updateData.current.create.Pricing && updateData.current.create.Pricing[type])
                delete updateData.current.create.Pricing![type]![mileage];
        }
    };

    const manageUpdateSelec = (updateKey: string, value: string, previousValue: string) => {
        if (["Energy", "SubSection", "Type", "Category"].includes(updateKey)) {
            var myVal: string | undefined;
            if (updateKey == "Energy")
                myVal = dbEnergy.filter(x => x.Name.toLowerCase() == value.toLowerCase())[0].id;
            else if (updateKey == "Type")
                myVal = dbCarType.filter(x => x.Name.toLowerCase() == value.toLowerCase())[0].id;
            else if (updateKey == "Category") {
                myVal = dbCategories.filter(x => x.Name.toLowerCase() == value.toLowerCase())[0].id;
            }
            if (myVal)
                value = myVal;
        }
        let datatoUpdate = updateData.current.update.carData;
        if (value !== previousValue) {
            if (!updateData.current.update.carData)
                updateData.current.update.carData = {};
            setUpdate(true);
            updateData.current.update.carData[updateKey] = value;
        } else if (datatoUpdate && datatoUpdate[updateKey]) {
            datatoUpdate[updateKey] = undefined;
        }
    }

    function InputCar(valueName: string, carValue: CarInputType, carValueSetter: Function, idx: number) {
        let myInput: JSX.Element | null = null;
        switch (typeof carValue) {
            case "string":
                if (valueName.includes("Gears"))
                    myInput = <CarSelect item={gears[0].toUpperCase()} updateCallBack={manageUpdateSelec} updateKey={"Gears"} optionsList={dbgears} keyTrad={"car.gears"} disabled={editable} />
                else if (valueName.includes("SubSection"))
                    myInput = <CarSelect item={subSection[0].toUpperCase()} updateCallBack={manageUpdateSelec} updateKey={"SubSection"} optionsList={Object.keys(dbSubSection)} keyTrad={"carType"} disabled={editable} />
                else if (valueName.includes("Energy")) {
                    myInput = <CarSelect item={energy[0].toUpperCase()} updateCallBack={manageUpdateSelec} updateKey={"Energy"} optionsList={dbEnergy.map(x => x.Name)} keyTrad={"energyType"} disabled={editable} />
                } else if (valueName.includes("CustomText"))
                    myInput = <input maxLength={16} type="text" onChange={(e) => {handleCarDataUpdate(valueName as keyof UpdateCarInfo, e.target.value); carValueSetter(e.target.value.toString())}} value={carValue} disabled={!editable} />
                else if (valueName.includes("Type"))
                    myInput = <CarSelect item={type[0].toUpperCase()} updateCallBack={manageUpdateSelec} updateKey={"Type"} optionsList={dbCarType.map(x => x.Name)} keyTrad={""} disabled={editable} />
                else if (valueName.includes("Category"))
                    myInput = <CarSelect item={category[0].toUpperCase()} updateCallBack={manageUpdateSelec} updateKey={"Category"} optionsList={dbCategories.map(x => x.Name)} keyTrad={""} disabled={editable} />
                else
                    myInput = <input type="text" className={`${carValue.length > 30 ? "w-75": "" } text-uppercase`} onChange={(e) => {handleCarDataUpdate(valueName as keyof UpdateCarInfo, e.target.value); carValueSetter(e.target.value.toString())}} value={carValue} disabled={!editable} />;
                break;
            case "number":
                myInput = <input type="number" min={0} step={100} onChange={(e) => {handleCarDataUpdate(valueName as keyof UpdateCarInfo, parseInt(e.target.value)); carValueSetter(parseInt(e.target.value))}} value={carValue < 0 ? 0 : carValue } disabled={!editable} />
                break;
            case "boolean":
                myInput = <div style={{flexDirection: "row", display: "flex"}}>
                        <span>{translator.decode("dynamic.no")}</span>
                            <Form.Check className="ms-2" type="switch" checked={carValue} onChange={(e) => {handleCarDataUpdate(valueName as keyof UpdateCarInfo, e.target.checked); carValueSetter(e.target.checked)}} disabled={!editable}/>
                        <span>{translator.decode("dynamic.yes")}</span>
                    </div>;
                break;
            case "object":
                if (carValue === null)
                    break;
                // let date = dateFormat(carValue, "yyyy-mm-dd");
                // myInput = <input type="date" onChange={(e) => {handleCarDataUpdate(myValueName as keyof UpdateCarInfo, new Date(e.target.value)); carValueSetter(new Date(e.target.value))}} value={date} disabled={!editable} />;
                break;
            default:
                break;
        };
        return <div key={`${valueName}-${idx}`} className="d-flex justify-content-between">
                    <span className="text-capitalize"> {translator.decode(`car.${valueName}`)} </span>
                    {myInput}
                </div>;
    };

    const handleCarDataUpdate = (attrName: keyof UpdateCarInfo, value: any, idx?: number) => {
        let datatoUpdate = updateData.current.update.carData;
        if (!datatoUpdate)
            datatoUpdate = {};
        if (attrName in datatoUpdate) {
            if (idx) {
                if (attrName in updateData.current.update && datatoUpdate[attrName] === undefined)
                    Object.defineProperty(datatoUpdate, attrName, [] as string[]);
                datatoUpdate[attrName] = value;
            } else
                datatoUpdate[attrName] = value;
            setUpdate(true);
        } else if (attrName.length > 0) {
            if (idx) {}
            else
                datatoUpdate[attrName] = value;
            setUpdate(true);
        }
        updateData.current.update.carData = datatoUpdate;
    };

    const handleSubmit = async () => {
        setSpinner(true);
        try {
            if (update) {
                let updated = false;
                if (updateData.current.update.carData || updateData.current.create.EquipmentsToCreate || updateData.current.delete.Pricing || updateData.current.create.Pricing || updateData.current.update.Pricing) {
                    let car = await CarService.setCarByID(loadData.id, updateData.current);
                    if (car)
                        updated = true;
                }
                var tmp: CarPictureType[] = [];
                if (updateData.current.delete.PictureToDelete !== undefined) {
                    tmp.push(...pictureList.filter(x => !x.toDelete).sort((y, z) => y.Index - z.Index).map((val, idx) => {return { ...val, Index: idx}}));
                    var toUpdate = [];
                    for (let item of picturesRef.current) {
                        const match = tmp.find(x => x.id === item.id && item.Index !== x.Index);
                        if (match)
                            toUpdate.push(match);
                    }
                    updateData.current.update.pictureData = toUpdate;
                }
                if (updateData.current.update.pictureData) {
                    let car = await CarService.setCarPicturesByID(loadData.id, updateData.current);
                    if (car) {
                        updated = true;
                        if (tmp.length > 0)
                            setPictureList(tmp);
                        updateData.current.delete.PictureToDelete = [];
                    }
                }
                if (updated) {
                    setIsOkay(true);
                    setOpenModal(true);
                } else {
                    setIsOkay(false);
                    setOpenModal(true);
                }
            }
            updateData.current = {update: {}, create: {}, delete: {}};
            setUpdate(false);
            setSpinner(false);
        } catch (error) {
            setIsOkay(false);
            setOpenModal(true);
            setSpinner(false);
        }
    };

    const buildRows = (input: building) => {
        let myRows: JSX.Element[] = [];
        Object.entries(input).forEach((val, index) => {
            myRows.push(InputCar(val[0], val[1][0], val[1][1], index));
        });
        return myRows;
    };

    const myDataLeft = useMemo(() => {
        return buildRows(dataLeftColumn);
    }, [brand[0], model[0], version[0]]);

    const myDataRight = useMemo(() => {
        return buildRows(dataRightColumn);
    }, [energy[0], type[0], color[0]]);

    const myPricingLeftRows = useMemo(() => {
        return buildRows(dataPricingLeft);
    }, [gears[0], customText[0], subSection[0], category[0]]);

    useEffect(() => {
        setBoxes(pictureList.map(val => {return {id: val.id, order: val.Index, Name: val.Pict.Name, Url: val.Pict.URI, toDelete: val.toDelete}}));
    }, [pictureList]);

    const handlePictureDelete = ((id: string) => {
        let picture = pictureList.find((val) => val.id == id);
        if (!picture)
            return null;
        if (!updateData.current.delete.PictureToDelete)
            updateData.current.delete.PictureToDelete = [];
        updateData.current.delete.PictureToDelete.push(picture.id);
        picture.toDelete = true;
        setUpdate(true);
        setPictureList([...pictureList]);
    });

    const handlePictureUpdate = (boxes: any[], ...updatedBoxes: any[]) => {
        setUpdate(true);
        updateData.current.update.pictureData = updateData.current.update.pictureData?.filter((val) => !updatedBoxes.map(v => v.id).includes(val.id));
        updateData.current.update.pictureData = [...(updateData.current.update.pictureData ?? []), ...updatedBoxes.map((val) => {
            return {
                id: val.id,
                Index: val.order
            };
        })];
        for (let box of updatedBoxes) {
            let picture = pictureList.find(val => val.id === box.id);
            if (picture)
                picture.Index = box.order;
        }
        setPictureList([...pictureList]);
    };

    const getStatusStyle = (style: string) => {
        var myClass: string = "";
        switch (style.toUpperCase()) {
            case "SOLD":
                myClass = Styles.sold;
                break;
            case "RESERVED":
                myClass = Styles.reserved;
                break;
            default:
                break;
        }
        return myClass;
    };

    return(
        <Fragment>
            {
                spinner ?
                    <div className={`${Styles.spinnerHolder}`}>
                        <LoadingScreen />
                    </div>
                    :null
            }
            <div className={`${Styles.carHolder}`}>
                {/* <button onClick={() => console.log(loaRef.current, lldRef.current)}>titi</button>
                <button onClick={() => console.log(pricingSave.current)}>tata</button>
                <button onClick={() => console.log(updateData.current)}>toto</button> */}
                <h1 className={`${Styles.title}`}> {cardTitle[0].toUpperCase()} </h1>
                <h2 className={`${Styles.title}`}> {version[0].toUpperCase()} </h2>
                <div className={`${Styles.title} ${Styles.carStatus}`}>
                    <h3 className={`${getStatusStyle(status[0])}`}>{translator.decode(`car.status.${status[0].toLowerCase()}`)}</h3>
                    {
                        editable ?
                        <CarSelect item={status[0]} updateCallBack={manageUpdateSelec} updateKey={"Status"} optionsList={Config.COMMON.CARSTATUS} keyTrad={"car.status"} label={translator.decode("dynamic.status")} disabled={editable} />
                        : null
                    }
                </div>
                <div className="d-flex justify-content-between align-items-center">
                    <BackArrow />
                    <div className={`${Styles.actionBtn}`}>
                        <button className="btn btn-outline-info" onClick={() => setOpenSendCarModal(true)}> {translator.decode("car.SendCarToClient")} </button>
                        {
                            editable ?
                            <>
                                {/* <button className="btn btn-outline-info" onClick={(e) => setOpenPictureModal(true)}> {translator.decode("car.add_pictures")} </button> */}
                                <button className="btn btn-outline-success" disabled={!update} onClick={handleSubmit}> {translator.decode("car.Save")} </button>
                                {/* <button className="btn btn-outline-primary" onClick={handleRetrievePictures}> {translator.decode("car.get_pictures")} </button> */}
                            </>
                            : null
                        }
                    </div>
                </div>
                <CollapseDiv title={translator.decode("car.Galery")}>
                    <DragGalery editable={editable} items={boxes} func={handlePictureUpdate} onDelete={handlePictureDelete}/>
                </CollapseDiv>
                <CollapseDiv title={translator.decode("car.CarData")}>
                    <CarInfo editable={editable} updatedCarObject={updateData.current} commentary={commentary} changeCommentary={(val: string) => { handleCarDataUpdate("Comments", val); setCommentary(val); } } carCustomSubTitle={carCustomSubTitle} changeCarCustomSubTitle={setCarCustomSubTitle}
                        dataLeftColumn={myDataLeft} dataRightColumn={myDataRight}
                        dataPricingLeft={myPricingLeftRows} dataPricingRight={[]} dataURL={[]}/>
                </CollapseDiv>
                <CollapseDiv title={translator.decode("car.Pricing")}>
                    <Pricing editable={editable} cb={() => { } } LOA={loaRef.current} LLD={lldRef.current} deletePricing={manageDeletePricing} updatePricing={manageUpdatePricing}/>
                </CollapseDiv>
                <CollapseDiv title={translator.decode("car.Equipment")}>
                    <CarEquipment carUpdate={updateData.current} id={loadData.id} disabled={!editable} />
                </CollapseDiv>
            </div>
            <ModalConfirmation show={openModal} onClose={() => setOpenModal(false)} closeModal={() => setOpenModal(false)} isOkay={isOkay} />
            <ModalCarPicture title={translator.decode("car.add_pictures")} carID={loadData.id} carIdx={boxes.length} show={openPictureModal} onClose={() => setOpenPictureModal(false)} closeModal={() => setOpenPictureModal(false)} name={model[0].toString()} />
            <ModalSearchUser carID={loadData.id} show={openSendCarModal} onClose={() => setOpenSendCarModal(false)} closeModal={() => setOpenSendCarModal(false)} title={translator.decode("car.SendCarToClient")} />
        </Fragment>
    )
}
